import React from 'react';
import { NavLink } from 'react-router-dom';
import './AdminSectionSwitch.css';

export const ADMIN_SECTIONS = [
  { to: '/dashboard', label: 'Candidaturas' },
  { to: '/manage-roles', label: 'Roles' },
  { to: '/manage-jury', label: 'Jurado' },
];

const AdminSectionSwitch: React.FC = () => (
  <nav className="admin-switch" aria-label="Secciones de gestión">
    {ADMIN_SECTIONS.map((s) => (
      <NavLink
        key={s.to}
        to={s.to}
        className={({ isActive }) => `admin-switch-item${isActive ? ' active' : ''}`}
      >
        {s.label}
      </NavLink>
    ))}
  </nav>
);

export default AdminSectionSwitch;
